// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  hasEmptyValue,
  pathContainsSubstring,
} from 'redux/modules/projectSummary/helpers'

const filterPaths = paths => (dispatch, getState) => {
  const { projectSummary } = getState()

  // inputs which are found in the project summary header
  const filterInput = projectSummary.get('filterInput').toLowerCase()
  const filterSelect = projectSummary.get('filterSelect')
  const filterCheckbox = projectSummary.get('filterCheckbox')

  // if neither of these have value, there's no filtering to apply
  const applyFilter = !!filterInput || !!filterCheckbox

  return paths.reduce((a, d, i) => {
    if (
      // when there's no filter to check for, skip the checks entirely
      !applyFilter ||
      // if the checkbox is checked, then we want to display
      // all paths that do not have a value assigned for the
      // entity which is specified in the select element.
      // so, like an un-filter
      filterCheckbox && hasEmptyValue(filterSelect, d) ||
      // if the checkbox isn't checked, then check to see if the text input
      // contains a substring value corresponding to the specified entity on filterSelect
      !filterCheckbox && pathContainsSubstring(d, filterSelect, filterInput)
    ) {
      a.push(d)
    }

    return a
  }, [])
}

export default filterPaths
